import { QSET_REVIEW_SUBTASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { NavigateBackLink, QSetReviewStatusTag } from '@exam-management/components';
import { WorkflowStepCode } from '@exam-management/graphql';
import { Divider, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';
import { matchPath, useLocation } from 'react-router-dom';

import { useQSetReviewSubtask } from '../../providers';
import { QSetReviewSubtaskNavigationTabs } from '../qset-review-subtask-navigation-tabs';
import { QSetReviewSubtaskPageHeaderMenu } from '../qset-review-subtask-page-header-menu';
import { SubmitReviewButton } from '../submit-review-button';

export default function QSetReviewSubtaskPageHeader() {
  const { subtaskDetails, roles } = useQSetReviewSubtask();
  const location = useLocation();
  const matchedTaskManagement = matchPath(
    '/task-management/qset-review/:taskId/*',
    location.pathname,
  );
  const matchedMyTask = matchPath('/my-task/qset-review/:taskId/*', location.pathname);
  const taskId = matchedTaskManagement?.params.taskId ?? matchedMyTask?.params.taskId ?? '';
  const isReviewerView = !matchedTaskManagement && roles.isAssignee;
  return (
    <PageHeader
      title={subtaskDetails.name}
      linkAdornment={
        <NavigateBackLink
          to={
            matchedTaskManagement
              ? '/task-management/qset-review/:taskId'
              : '/my-task/qset-review/:taskId'
          }
          params={{
            taskId,
          }}
          replace
        />
      }
      endAdornment={
        <>
          <QSetReviewStatusTag
            status={subtaskDetails.currentWorkflowStep.code}
            data-testid={QSET_REVIEW_SUBTASK_DATA_TEST_ID.STATUS_TAG}
          />
          <Divider orientation='vertical' flexItem />
          {isReviewerView &&
          subtaskDetails.currentWorkflowStep.code === WorkflowStepCode.ReviewQsetInReview ? (
            <SubmitReviewButton />
          ) : null}
          <QSetReviewSubtaskPageHeaderMenu />
        </>
      }
      subtitleSection={
        <>
          <Text variant='body2'>Task ID: {subtaskDetails.code}</Text>
          <Text variant='body2'>Last Modified: {formatDateTime(subtaskDetails.updatedAt)}</Text>
        </>
      }
      tabs={<QSetReviewSubtaskNavigationTabs />}
    />
  );
}
